import { useState } from 'react';
import type { GalleryItem } from '@/mocks/galleryData';

interface GalleryCardProps {
  item: GalleryItem;
  index: number;
  onClick: (item: GalleryItem) => void;
}

export default function GalleryCard({ item, index, onClick }: GalleryCardProps) {
  const [error, setError] = useState(false);

  return (
    <button
      onClick={() => onClick(item)}
      className="group relative w-full aspect-square overflow-hidden rounded-lg bg-gray-100 cursor-pointer focus:outline-none"
      aria-label={`갤러리 ${index + 1}번 이미지 보기`}
    >
      {!error ? (
        <img
          src={item.thumbnail}
          alt={item.title ?? `갤러리 ${index + 1}`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          onError={() => setError(true)}
        />
      ) : (
        <div className="w-full h-full flex flex-col items-center justify-center text-gray-300 gap-1">
          <i className="ri-image-line text-3xl" />
          <span className="text-xs">이미지 없음</span>
        </div>
      )}

      {/* Hover overlay */}
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/30 transition-all duration-300 flex items-end justify-start p-2">
        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center gap-1.5">
          <div className="w-7 h-7 flex items-center justify-center rounded-full bg-white/90">
            <i className="ri-zoom-in-line text-gray-700 text-sm" />
          </div>
          {item.title && (
            <span className="text-white text-xs font-medium bg-black/50 rounded px-2 py-0.5 whitespace-nowrap">
              {item.title}
            </span>
          )}
        </div>
      </div>
    </button>
  );
}
